import { useState } from "react";
import { Plus, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export default function NuovaLavorazioneButton({ cantiereId, onCreated, className = "" }) {
  const [open, setOpen] = useState(false);
  const [nome, setNome] = useState("");
  const [descrizione, setDescrizione] = useState("");
  const [saving, setSaving] = useState(false);

  const salva = async (event) => {
    event.preventDefault();
    // Il dialog può essere aperto dentro il form di una fattura o di un'altra
    // scheda. Il submit deve creare solo la lavorazione, senza salvare il form
    // esterno: l'utente lo confermerà poi con il normale pulsante Salva.
    event.stopPropagation();
    if (!cantiereId) return toast.error("Seleziona prima il cantiere");
    if (!nome.trim()) return toast.error("Inserisci il nome della lavorazione");
    setSaving(true);
    try {
      const { data } = await api.post(`/cantieri/${cantiereId}/lavorazioni`, {
        nome: nome.trim(), descrizione: descrizione.trim(), stato: "In corso",
      });
      setNome("");
      setDescrizione("");
      setOpen(false);
      // La selezione viene applicata dopo la chiusura del dialog interno.
      // In questo modo il Select della scheda principale non può ripristinare
      // il valore precedente durante il riposizionamento del focus.
      window.setTimeout(() => {
        onCreated?.(data);
        toast.success("Lavorazione creata e selezionata");
      }, 0);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail || "Creazione non riuscita"));
    } finally { setSaving(false); }
  };

  return <>
    <Button type="button" variant="outline" size="sm" disabled={!cantiereId} onClick={() => setOpen(true)} className={className}>
      <Plus className="mr-1.5 h-4 w-4"/>Nuova lavorazione
    </Button>
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="sm:max-w-md">
        <form onSubmit={salva}>
          <DialogHeader><DialogTitle>Nuova lavorazione</DialogTitle><DialogDescription>Verrà collegata al cantiere selezionato.</DialogDescription></DialogHeader>
          <div className="my-5 space-y-4">
            <div><Label>Nome *</Label><Input autoFocus value={nome} onChange={(e) => setNome(e.target.value)} placeholder="Es. Impianto elettrico" className="mt-1.5"/></div>
            <div><Label>Descrizione</Label><Textarea value={descrizione} onChange={(e) => setDescrizione(e.target.value)} placeholder="Descrizione facoltativa" className="mt-1.5"/></div>
          </div>
          <DialogFooter><Button type="button" variant="outline" onClick={() => setOpen(false)}>Annulla</Button><Button type="submit" disabled={saving}>{saving && <Loader2 className="mr-2 h-4 w-4 animate-spin"/>}Crea e seleziona</Button></DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  </>;
}
